/*
	Joonys: Shopify-Forms-Embeds an die CI angleichen.

	Das Embed rendert in einem offenen Shadow DOM. Farben und Schriften laufen über
	CSS-Variablen (siehe joonys-overrides.css), die sich durch die Shadow-Grenze vererben.
	Alles, was die Variablen nicht abdecken, wird hier als Stylesheet in den Shadow-Root
	gelegt. Bewusst nur Element-/Attribut-Selektoren, die gehashten Klassennamen der App
	sind bei Updates instabil.

	Labels, Placeholder und Feld-Innenabstaende bleiben bewusst unangetastet: die App
	nutzt schwebende Labels und rechnet das Padding passend dazu aus.

	Greift auf jedes shopify-forms-embed im Theme: Popup in den Kontakt-Karten,
	Inline-Formulare in der Apps-Sektion, Landingpages.
*/
(function () {
	var SHADOW_CSS = [
		/* Ueberschriften wie im Theme: Heading-Font, Kerning, enge Zeilenhoehe.
		   rem loest im Shadow DOM gegen das Dokument auf, 1rem = 10px im Theme. */
		'h1, h2, h3, h4, h5, h6 {',
		'	font-family: var(--heading-font-family) !important;',
		'	font-style: var(--heading-font-style) !important;',
		'	font-weight: var(--heading-font-weight) !important;',
		'	font-size: clamp(2.2rem, 1.4rem + 1.2vw, 2.8rem) !important;',
		'	line-height: 1.02 !important;',
		'	letter-spacing: -0.01em !important;',
		'	color: var(--heading-text-color) !important;',
		'	margin: 0 0 0.8rem !important;',
		'}',
		/* Formular-Kopf: Beschreibung unter der Ueberschrift wie eine Theme-Unterzeile */
		'[class*="formHeader"] {',
		'	margin-bottom: 2.4rem;',
		'}',
		'[class*="formHeader"] [class*="textBody"],',
		'[class*="formHeader"] [class*="textBody"] p {',
		'	font-size: 2rem !important;',
		'	line-height: 1.35 !important;',
		'	color: var(--body-text-color) !important;',
		'}',
		'[class*="formHeader"] [class*="textBody"] p {',
		'	margin: 0 !important;',
		'}',
		'textarea {',
		'	width: 100% !important;',
		'	box-sizing: border-box !important;',
		'}',
		'form {',
		'	display: flex;',
		'	flex-wrap: wrap;',
		'	align-items: center;',
		'	justify-content: flex-end;',
		'}',
		'form > * {',
		'	flex: 0 0 100% !important;',
		'	width: 100% !important;',
		'	min-width: 0;',
		'}',
		/* Checkbox und Button teilen sich eine Zeile (siehe groupActions) */
		'.joonys-form-actions {',
		'	order: 9 !important;',
		'	flex: 0 0 100% !important;',
		'	width: 100% !important;',
		'	display: flex;',
		'	align-items: center;',
		'	justify-content: flex-end;',
		'	gap: 1.6rem;',
		'	margin-top: 0.8rem;',
		'}',
		'.joonys-form-actions > *:has([name="emailConsent"]) {',
		'	flex: 0 1 auto !important;',
		'	width: auto !important;',
		'	margin: 0 !important;',
		'	text-align: left;',
		'}',
		'button[type="submit"] {',
		'	flex: 0 0 auto !important;',
		'	width: auto !important;',
		'	min-width: 18rem;',
		'	margin-left: 0 !important;',
		'	padding-left: 3rem !important;',
		'	padding-right: 3rem !important;',
		'	font-family: var(--body-font-family) !important;',
		'	font-weight: 900 !important;',
		'	text-transform: uppercase !important;',
		'	letter-spacing: 0.04em;',
		'}',
		'input[type="checkbox"] {',
		'	accent-color: var(--forms-accent-color);',
		'	width: 18px !important;',
		'	height: 18px !important;',
		'	flex: 0 0 18px;',
		'}'
	].join('\n');

	/*
		Checkbox und Absenden-Button in eine gemeinsame Zeile.
		Über flex-order allein bricht der Button um, deshalb ein echter Wrapper.
	*/
	function groupActions(shadow) {
		if (shadow.querySelector('.joonys-form-actions')) {
			return;
		}

		var consentBox = shadow.querySelector('form > *:has([name="emailConsent"])');
		var submitButton = shadow.querySelector('form > button[type="submit"]');

		if (!consentBox || !submitButton) {
			return;
		}

		var actions = document.createElement('div');
		actions.className = 'joonys-form-actions';
		submitButton.parentElement.appendChild(actions);
		actions.appendChild(consentBox);
		actions.appendChild(submitButton);
	}

	function styleEmbed(embed) {
		var shadow = embed.shadowRoot;

		if (!shadow) {
			return;
		}

		groupActions(shadow);

		/* Das Embed rendert mehrfach nach, der Observer wendet alles erneut an */
		if (!embed.hasAttribute('data-joonys-observed')) {
			embed.setAttribute('data-joonys-observed', '');
			new MutationObserver(function () {
				groupActions(shadow);
			}).observe(shadow, { childList: true, subtree: true });
		}

		if (shadow.querySelector('style[data-joonys-forms]')) {
			return;
		}

		var style = document.createElement('style');
		style.setAttribute('data-joonys-forms', '');
		style.textContent = SHADOW_CSS;
		shadow.appendChild(style);
	}

	function styleAll() {
		document.querySelectorAll('shopify-forms-embed').forEach(styleEmbed);
	}

	window.joonysStyleForms = styleAll;

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', styleAll);
	} else {
		styleAll();
	}

	/* Embeds tauchen erst auf, wenn die App geladen hat oder ein Popup öffnet */
	new MutationObserver(styleAll).observe(document.documentElement, { childList: true, subtree: true });
})();
